module.exports = __webpack_public_path__ + "static/media/lamina28act2_1.39340453.png";